<template>
  <div>
    <!-- title -->
    <div class="server-info-title title">
      <span>Common statistics</span>
    </div>
    <!-- RAM usage statistics -->
    <div class="info-block info-block__wrapper">
      <span class="subtitle">Common memory usage</span>
      <div class="info-data">
        <memory-usage-bar
          :full-memory="commonMemory"
          :used-memory="commonMemoryUsage"
          class="info-usage-bar"
        />
      </div>
    </div>
    <!-- CPU usage statistics -->
    <div class="info-block info-block__wrapper">
      <span class="subtitle">Average CPU usage</span>
      <div class="info-data">
        <percentage-usage-bar :usage="averageCpuUsage" class="info-usage-bar" />
      </div>
    </div>

    <!-- Servers list -->
    <admin-servers-list
      :servers="servers"
      @serverSelected="$emit('serverSelected', { server: $event.server })"
    />
  </div>
</template>

<script>
import PercentageUsageBar from "@/components/admin/bars/PercentageUsageBar.vue";
import MemoryUsageBar from "@/components/admin/bars/MemoryUsageBar.vue";
import AdminServersList from "@/components/admin/main/common/AdminServersList.vue";

// @group Admin Page
// Common servers statistics panel
export default {
  name: "AdminCommonInfo",
  components: {
    PercentageUsageBar,
    MemoryUsageBar,
    AdminServersList
  },
  props: {
    // servers information
    servers: {
      type: Array,
      required: true
    }
  },
  computed: {
    // @vuese
    // Enabled servers list
    activeServers() {
      return this.servers.filter(s => s.active);
    },
    // @vuese
    // Sum of all servers memory
    commonMemory() {
      return this.activeServers.reduce((mem, s) => mem + s.fullMemory, 0);
    },
    // @vuese
    // Sum of all servers used memory
    commonMemoryUsage() {
      return this.activeServers.reduce((mem, s) => mem + s.memoryUsage, 0);
    },
    // @vuese
    // Average CPU usage
    averageCpuUsage() {
      const servers = this.activeServers;

      if (servers.length == 0) {
        return 0;
      }

      /** sum of all active servers CPUs */
      const cpuSum = servers.reduce((cpu, s) => cpu + s.cpuUsage, 0);
      /** get average CPU */
      const averageCpuUsage = cpuSum / servers.length;

      return averageCpuUsage;
    }
  }
};
</script>

<style scoped>
.server-info-title {
  display: flex;
  align-items: center;
  padding-bottom: 0.5em;
}

.server-status {
  padding-left: 5px;
  padding-bottom: 4px;
  font-size: 2rem;

  color: var(--success-color);
}

.server-status.disabled {
  color: var(--error-color);
}

.info-block {
  display: flex;
  flex-direction: column;
}
.info-block__wrapper {
  padding-bottom: 1.5em;
}

.info-usage-bar {
  height: 50px;
  width: 100%;
}
.info-usage-bar__text {
  font-weight: bold;
}

.info-streams {
  display: flex;
  flex-direction: column;
}
.info-streams__wrapper {
  padding-left: 1em;
}
</style>
